import { createTimeRange } from './time-ranges.js';
export function bufferedPercent(buffered, duration) {
    var bufferedDuration = 0;
    var start;
    var end;
    if (!duration) {
        return 0;
    }
    if (!buffered || !buffered.length) {
        buffered = createTimeRange(0, 0);
    }
    for (var i = 0; i < buffered.length; i++) {
        start = buffered.start(i);
        end = buffered.end(i);
        if (end > duration) {
            end = duration;
        }
        bufferedDuration += end - start;
    }
    return bufferedDuration / duration;
}